"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var sendBoxValue = _ref.sendBoxValue;
  return sendBoxValue;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kQm94VmFsdWUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VsZWN0b3JzL3NlbmRCb3hWYWx1ZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFJlZHV4U3RhdGUgfSBmcm9tICcuLi90eXBlcy9pbnRlcm5hbC9SZWR1eFN0YXRlJztcblxuZXhwb3J0IGRlZmF1bHQgKHsgc2VuZEJveFZhbHVlIH06IFJlZHV4U3RhdGUpOiBzdHJpbmcgPT4gc2VuZEJveFZhbHVlO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O2VBRWU7RUFBQSxJQUFHQSxZQUFILFFBQUdBLFlBQUg7RUFBQSxPQUEwQ0EsWUFBMUM7QUFBQSxDIn0=